<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1 style="padding-top:100px;">Acknowledgments</h1>
<p style="text-indent:0px;">I am grateful to those who have read my previous work and encouraged me to continue writing.</p><br/>
<p style="text-indent:0px;">I also wish to thank Kate Yates, née Babcock, a friend of my youth and ever since, for permission to use her watercolour image on the cover.</p>
<div class="pagebreak"></div><p style="padding-top:150px;text-align:center;"><em>"When I was young, all lives but mine</em></p>
<p style="text-align:center"><em>Were windows in a house of stone</em></p>
<p style="text-align:center"><em>From which interior light did shine</em></p>
<p style="text-align:center"><em>On me, outside, alone."</em></p>
<p style="text-align:right">Charles Morgan</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4a02e7c2